<template>
  <el-dialog
    title="确认结果"
    :visible.sync="dialogVisible"
    width="500px"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <div class="descicon"></div>
    <span class="font16">请确认实际检测费用</span>
    <el-descriptions :column="3" id="goods_details" style="margin-top: 10px;margin-left: 20px">
      <el-descriptions-item label="支付方式" span="3">
        {{ dictFilter(form.prepaidPayment ? form.prepaidPayment.toString() : '-',
        'prepaidPayment') }}
      </el-descriptions-item>
      <el-descriptions-item label="原支付金额" span="3">¥{{ form.totalCost }}</el-descriptions-item>
      <el-descriptions-item label="实际检测金额" span="3">¥{{ form.experimentTotalCost }}</el-descriptions-item>
    </el-descriptions>
    <div style="margin-bottom: 10px;">
      <div class="descicon"></div>
      <span class="font16">注意事项</span>
    </div>
    <el-descriptions :column="3" id="goods_details" style="margin-left: 13px" :colon="false"> 
      <el-descriptions-item span="3" v-if="form.totalCost != form.experimentTotalCost">
        <div v-if="form.totalCost < form.experimentTotalCost">
          <span v-if="form.prepaidPayment != 3 && form.prepaidPayment != 4">
            确认后将从
            <span style="color: #F0A74A">{{ dictFilter(form.prepaidPayment ? form.prepaidPayment.toString() : '-',
        'prepaidPayment') }}</span>中
            <span style="color: #F0A74A">扣除差价</span>
          </span>
          <span v-else>
            <span style="color: #F0A74A">补充支付差价后</span>完成订单确认
          </span>
        </div>
        <div v-if="form.totalCost > form.experimentTotalCost">
          <span v-if="form.prepaidPayment != 3 && form.prepaidPayment != 4">
            确认后将按照支付方式
            <span style="color: #F0A74A">原路退回差价</span>
          </span>
          <span v-else>
            确认后差价将
            <span style="color: #F0A74A">退回至个人预存款中</span>
          </span>
        </div>
      </el-descriptions-item>
      <el-descriptions-item span="3">
          <span>请先确认结果，</span>
          <span style="color: #F0A74A">才能下载实验数据</span>
      </el-descriptions-item>
      <el-descriptions-item span="3">
          <span>
            <span>确认结果后，平台仅为您保存为期</span>
            <span style="color: #FF4A2B;">180天</span>
            <span>的实验数据，请及时下载！下载的数据，如有异议请于</span>  
            <span style="color: #FF4A2B;">7日</span>
            <span>内反馈，我们将及时沟通处置。</span>
          </span>
      </el-descriptions-item>
    </el-descriptions>

    <div slot="footer" class="footerBox">
      <el-button
        type="primary"
        size="small"
        v-if="(form.prepaidPayment == 3 || form.prepaidPayment == 4) && this.form.cashPriceDifference > 0"
        style="width: 80px"
        @click="toPayHandle()"
        v-preventClick
      >前往支付</el-button>
      <el-button
        type="primary"
        size="small"
        v-else
        @click="submitHandle()"
        v-preventClick
      >确认结果并下载实验数据</el-button>
      <el-button size="small" plain @click="dialogVisible = false">返回</el-button>
    </div>
    <!-- 确认评价 -->
    <evaluation ref="evaluation" v-if="evaluationVisible" @close="close"></evaluation>
    <!-- 微信支付弹窗 -->
    <we-chat-pay
      @creatOrder="creatOrder"
      @closeWxPay="closeWxPay"
      :wxPayInfo="wxPayInfo"
      v-if="weChatPayStatus"
    ></we-chat-pay>
    <!-- 支付宝支付弹窗 -->
    <alipay
      @creatALiPayOrder="creatALiPayOrder"
      @closeALiPayOrder="closeALiPayOrder"
      v-if="aliPayStatus"
      ref="alipay"
      :aliPayOrder="aliPayOrder"
    ></alipay>
  </el-dialog>
</template>
<script>
import {
  finishOrder,
  makeUpMoneyWx,
  makeUpMoneyAli,
  editOrderMoney
} from "@/api/request";
import evaluation from "./evaluation";
import weChatPay from "../../common/WeChatPayPop.vue";
import Alipay from "../../common/Alipay.vue";
export default {
  components: { evaluation, weChatPay, Alipay },
  data() {
    return {
      dialogVisible: false,
      evaluationVisible: false,
      wxPayInfo: null,
      aliPayOrder: null,
      weChatPayStatus: false,
      aliPayStatus: false,
      form: {}
    };
  },
  methods: {
    init(info) {
      this.dialogVisible = true;
      this.evaluationVisible = false;
      this.$nextTick(() => {
        this.form = { ...info };
      });
    },
    creatOrder() {
      this.wxPayInfo = null;
      this.weChatPayStatus = false;
      this.evaluationVisible = true;
      this.dialogVisible = false;
      this.$nextTick(() => {
        this.$refs.evaluation.init(this.form);
      });
    },
    creatALiPayOrder() {
      this.aliPayOrder = null;
      this.aliPayStatus = false;
      this.evaluationVisible = true;
      this.dialogVisible = false;
      this.$nextTick(() => {
        this.$refs.evaluation.init(this.form);
      });
    },
    closeWxPay() {
      this.wxPayInfo = null;
      this.weChatPayStatus = false;
    },
    closeALiPayOrder() {
      this.aliPayOrder = null;
      this.aliPayStatus = false;
    },
    //前往支付
    toPayHandle() {
      if (this.form.cashPriceDifference > 0) {
        if (this.form.prepaidPayment == 3) {
          let orderInfo = {
            detectionCode: this.form.detectionCode,
            price: this.form.cashPriceDifference, //单位是元
            goodsName: this.form.equipmentName, //商品描述 取得设备名称
            notifyUrl: process.env.VUE_APP_PAY_API //回调地址 通知url必须为外网可访问的url，不能携带参数。 公网域名必须为https，如果是走专线接入，使用专线NAT IP或者私有回调域名可使用http
          };
          makeUpMoneyAli(orderInfo)
            .then(res => {
              this.aliPayOrder = {
                barcodeText: res.data.body,
                orderCode: res.data.orderCode,
                orderId: this.form.orderId,
                subscribeId: this.form.subscribeId,
                price: this.form.cashPriceDifference,
                flag: true, //是否是补差价
                goodsName: this.form.equipmentName
              };
              this.aliPayStatus = true;
              this.$nextTick(() => {
                this.$refs.alipay.init(this.aliPayOrder);
              });
            })
            .catch(err => {});
        } else {
          let orderInfo = {
            detectionCode: this.form.detectionCode,
            totalPrice: this.form.cashPriceDifference * 100, //后端金额单位为分 需要乘以100换算为分
            goodsName: this.form.equipmentName, //商品描述 取得设备名称
            notifyUrl: process.env.VUE_APP_PAY_API //回调地址 通知url必须为外网可访问的url，不能携带参数。 公网域名必须为https，如果是走专线接入，使用专线NAT IP或者私有回调域名可使用http
          };
          makeUpMoneyWx(orderInfo)
            .then(res => {
              this.wxPayInfo = res.data;
              this.wxPayInfo.totalCost = this.form.cashPriceDifference;
              this.wxPayInfo.flag = true;
              this.wxPayInfo.subscribeId = this.form.subscribeId;
              this.weChatPayStatus = true;
            })
            .catch(err => {});
        }
      } else {
        finishOrder({ orderId: this.form.orderId }).then(res => {
          this.$message.success("操作成功");
          this.evaluationVisible = true;
          this.dialogVisible = false;
          this.$nextTick(() => {
            this.$refs.evaluation.init(this.form);
          });
        });
      }
    },
    //确认结果
    submitHandle() {
      finishOrder({ orderId: this.form.orderId }).then(res => {
        this.dialogVisible = false;
        this.$message.success("操作成功");
        this.$emit('downloadResult', this.form)
        this.evaluationVisible = true;
        this.$nextTick(() => {
          this.$refs.evaluation.init(this.form);
        });
      });
    },
    close() {
      this.$emit("refesh");
    }
  }
};
</script>
